import { PropsWithChildren } from 'react';
import queryString from 'query-string';
import { QueryParamProvider as DefaultQueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

export function QueryParamProvider({ children }: PropsWithChildren<{}>) {
  return (
    <DefaultQueryParamProvider
      adapter={ReactRouter6Adapter}
      options={{
        searchStringToObject: queryString.parse,
        objectToSearchString: queryString.stringify,
        removeDefaultsFromUrl: true,
      }}
    >
      {children}
    </DefaultQueryParamProvider>
  );
}
